import { arrayProto } from './context'
const { splice: contextSplice } = arrayProto
export default contextSplice
